/* eslint-disable import/no-anonymous-default-export */
export default (redeemed = [], action) => {
  switch (action.type) {
    case "ALL_REDEEMED_INVESTMENT":
      return action.payload;
    case "REDEEM_INVESTMENT":
      return [...redeemed, action.payload];
    default:
      return redeemed;
  }
};
